<app-ui-main-menu>
    <mat-card>
        <mat-card-header>
            <mat-card-title>Carteira</mat-card-title>
          </mat-card-header>
          <mat-divider></mat-divider>
          <mat-card-content>
            <br /> 
            <div class="wallet-infos">
                <span style="font-size: 1.35rem;">
                    Saldo: 
                    <span class="amount">{{totalAmount | currency}}</span>
                </span>
            </div>
            <br /> 
            <div style="margin: 0.5px 0 35px 0 ;">
                <form class="form" [formGroup]="form" (ngSubmit)="onSubmit()">
                    <div class="row margin-top">
                        <div class="col-12 col-md-12">
                            <div class="row">
                                <div class="col-sm-8 col-lg-5" >
                                    <mat-form-field appearance="outline">
                                        <mat-label>Valor</mat-label>
                                        <input 
                                            matInput
                                            required
                                            type="text" 
                                            placeholder="0.000,00" 
                                            formControlName="amount"
                                            [mask]="'separator.2'" 
                                            thousandSeparator="." 
                                            decimalMarker="," 
                                            (change)="amountChange()"
                                            (blur)="amountFormat()"
                                        >
                                        <mat-error *ngIf="form.hasError('invalid', ['amount'])">
                                            Insira um valor minimo de R$ 100,00.
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div class="col-sm-4 col-lg-12 mt-2">
                                    <button
                                        mat-button
                                        class="btn-primary"
                                        type="submit"
                                    >Adicionar saldo
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            
            <mat-divider></mat-divider>
            
            <div class="reports-userwallet" style="display: flex; flex-direction: column; align-items: center;">
                <div style="display: flex; gap: 15px;">
                    <button
                        mat-button
                        class="btn-primary"
                        style="max-width: 250px;"
                    >
                        Ver extrato analítico
                    </button>
                    <button
                        mat-button
                        class="btn-primary"
                        style="max-width: 250px;"
                        (click)="downloadCsv()"
                        [disabled]="csvLoading"
                    >
                    <mat-spinner
                        *ngIf="csvLoading"
                        [diameter]="20"
                        color="accent"
                        style="position: absolute; top: 50%; transform: translateY(-50%); left: 42%"
                    ></mat-spinner>
                        Exportar CSV
                    </button>
                </div>
                <br />
                <br />
                <div class="col-12">
                    <div *ngIf="isLoading.active" class="d-flex justify-content-center">
                        <span>{{isLoading.message}}</span>
                    </div>
                    <table *ngIf="!isLoading.active">
                        <thead>                            
                            <tr>
                                <th>Data da movimentação</th>
                                <th>Tipo de Movimentação</th>
                                <th>Valor</th>
                                <th>Status da movimentação</th>
                                <th>Nome do paciente</th>
                                <th>Status do agendamento</th>
                                <th>Laudo</th>
                                <th>Movimentação</th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr *ngFor="let item of analyticReportList">
                                <td> {{ item.createAt | date}} às {{  item.createAt | date : "HH:mm:ss" }} </td>

                                <td> {{ item.type }} </td>

                                <td> {{ item.amount | currency }} </td>

                                <td
                                    [ngClass]="{
                                        'text-yellow': item.status === 'PENDING', 
                                        'text-green': item.status === 'RECEIVED', 
                                        'text-blue': item.status === 'REFOUND',
                                        'text-red' : item.status === 'EXPIRED'
                                    }"
                                > 
                                    {{ transactionStatus[item.status] || item.status }} 
                                </td>

                                <td> 
                                    <span *ngIf="item.indicationId > 0">{{item.patientName | uppercase }}</span>
                                    <span *ngIf="item.indicationId <= 0">-</span>
                                </td>

                                <td> {{item.attendanceStatus ? item.attendanceStatus : '-'}} </td>

                                <td>
                                    <span *ngIf="item.documentUrl" >
                                        <a
                                            href="javascript:void(0)"
                                            (click)="openLaudosModal(item)"
                                            style="color: black"
                                        >
                                            Ver Laudo
                                            <fa-icon title="Ver laudo" [icon]="'external-link-square-alt'" style="color: rgb(71, 71, 71);"></fa-icon>
                                        </a>
                                    </span>
                                    <span *ngIf="!item.documentUrl" > - </span>
                                </td>

                                <td>
                                    <!-- <span *ngIf="item.indicationId <= 0 || item.status === 'EXPIRED'">-</span> -->
                                    <span *ngIf="item.status === 'RECEIVED'">{{item.payment_method}}</span>
                                    <span *ngIf="item.status === 'REFOUND'">Valor estornado: {{ item.amount | currency }}</span>
                                    <span *ngIf="item.status === 'PENDING'"> 
                                        <a 
                                            [href]="item.paymentLink"
                                            target="_blank"
                                            style="color: black"
                                        >
                                            Link de pagamento
                                            <fa-icon title="Link de pagamento" [icon]="'external-link-square-alt'" style="color: rgb(71, 71, 71);"></fa-icon>
                                        </a>
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    
                    </table>
                    <br />
                    <div class="col-12 d-flex justify-content-center">
                        <button 
                            class="show"
                            *ngIf="btnShowMoreAnalytic"
                            (click)="showMore()"
                        >
                        Ver mais
                        </button>
                    </div>
                </div>
            </div>
          </mat-card-content>
    </mat-card>
</app-ui-main-menu>  